import React, { useEffect, useRef, useState, lazy, Suspense } from 'react'
import { useDidMountEffect } from '../services/hooks';
import { useSearchParams } from 'react-router-dom';
import { getPaymentInfoOneinc, getQuotePaymentInfo, retrieveOneIncSessionID, loadPaymentFromToken, loadPaymentFromShortcode, createBindToken, GetEnvironmentSettings, logPBT } from '../services/Api';
import AutoPayModal from './AutoPayModal';
import Loading from './Loading';
import { getSiteEnv, getDomainQuote, getDomainQuoteRedesign, getTestingEnvToken, getRedirectEnv, getMobileScheme } from '../services/Utils';
//import OtherOptions from './OtherOptions';
import NoPaymentDue from './NoPaymentDue';
import ClientInfo from './ClientInfo';
import PortalOne from './PortalOne';
import Cookies from 'js-cookie';
import PaymentDisclaimer from './PaymentDisclaimer';
import AutopayBlocked from './AutopayBlocked';
import { useLocation } from 'react-router-dom';

const OtherOptions = lazy(() => import("./OtherOptions"));

const Home = ({ env, setEnv }) => {
  const [searchParams] = useSearchParams();
  const [isPolicyPayment, setIsPolicyPayment] = useState(false)
  const isDownPayment = useRef(false)
  const [isAutopay, setIsAutopay] = useState(false)
  const [isTextToPay, setIsTextToPay] = useState(false)
  const [isPaymentMethod, setIsPaymentMethod] = useState(false)
  const [isModalReady, setIsModalReady] = useState(false)
  const sessionID = useRef("")
  const [isLoading, setIsLoading] = useState(true)
  const [showHomeMenu, setShowHomeMenu] = useState(true)
  const [showLoadingText, setShowLoadingText] = useState(true)
  const [errorMessage, setErrorMessage] = useState("")
  const paymentComplete = useRef(false)
  const [isPaymentComplete, setIsPaymentComplete] = useState(false)
  const isNotifications = useRef(false)
  const isDefaultPayment = useRef(false)
  const autopayIsComplete = useRef(false)
  const fromToken = useRef(false)
  const state = useRef("")
  const quoteID = useRef("")
  const confirmationNumber = useRef("")
  const amountPaid = useRef("")
  const paymentDate = useRef("")
  const email = useRef("")
  const [pol, setPol] = useState("")
  const [zip, setZip] = useState("")
  const type = useRef("")
  const [isQuote, setIsQuote] = useState(false)
  const source = useRef("")
  const portalOneRef = useRef(null)

  const [hasLoadedModal, setHasLoadedModal] = useState(false)
  const [showOtherOptions, setShowOtherOptions] = useState(false)
  const [showPaymentDisclaimer, setShowPaymentDisclaimer] = useState(false)
  const [showAutopayBlocked, setShowAutopayBlocked] = useState(false)
  const [showNoPaymentDue, setShowNoPaymentDue] = useState(false)
  const [showAutopay, setShowAutopay] = useState(false)
  const [userEnteredPolicy, setUserEnteredPolicy] = useState(false)
  const autopayManagePayMethods = useRef(false);
  const [typeD, setTypeD] = useState("")
  const [sourceD, setSourceD] = useState("")

  const bindToken = useRef("")
  const [continueObj, setContinueObj] = useState({})


  useEffect(() => {
    (async () => {
      if (window.location.hostname !== 'localhost' && Cookies.get('CTLE', { domain: '.cure.com' }) != getTestingEnvToken() && env != 'prod') {
        window.location = "https://www.cure.com";
      }

      window.addEventListener('beforeunload', () => {
        window.sessionStorage.setItem('prevUrl', window.location.href);
      });

      const autopayBlocked = window.sessionStorage.getItem('autopayBlocked')
      const prevUrl = window.sessionStorage.getItem('prevUrl');
      const currentUrl = window.location.href;

      if (prevUrl && prevUrl !== currentUrl && !!autopayBlocked) {
        GoBack({override:true});
      }

      let Pol
      let Zip
      let Env
      let Type
      let Source

      let IsAutopay
      let IsPolicyPayment
      let IsDownPayment
      let IsTextToPay
      let IsPaymentMethod
      let IsModalReady
      let IsQuote
      let SessionID

      await RetrieveOneIncSessionID(env)

      if ((searchParams.get("Token") !== null && searchParams.get("Token") !== "{{Token}}") || (searchParams.get("tkn") !== null && searchParams.get("tkn") !== "")) {
        const tokenData = searchParams.get("Token") !== null ? await loadPaymentFromToken(searchParams.get("Token")) : await loadPaymentFromShortcode(searchParams.get("tkn"))
        if (tokenData.Result === "Success" && !!tokenData.PolicyNumber && !!tokenData.Zip) {
          fromToken.current = true
          Pol = tokenData.PolicyNumber
          setPol(tokenData.PolicyNumber)
          Zip = tokenData.Zip
          setZip(tokenData.Zip)
          Env = tokenData.Env
          setEnv(tokenData.Env)
          Type = tokenData.Type
          setTypeD(tokenData.Type)
          type.current = Type
          Source = tokenData.Source
          setSourceD(tokenData.Source)
          source.current = Source
          IsQuote = /^(AP|\d+)/.test(Pol)
          setIsQuote(IsQuote)

          if(/^(QT)/.test(Pol)){
            ShowErrorMessage("There has been an issue with your application! Please call 800-535-2873 to speak with a representative.")
            return;
          }

          SessionID = await RetrieveOneIncSessionID(Env)

          if (Type === "payment") {
            setIsPolicyPayment(true)
            IsPolicyPayment = true
          } else if (Type === "autopay") {
            setIsAutopay(true)
            IsAutopay = true
          } else if (Type === "notifications") {
            setIsTextToPay(true)
            IsTextToPay = true
            await logPBT(Pol, Zip, Env);
          } else if (Type === "quote") {
            isDownPayment.current = true
            IsDownPayment = true
          } else if (Type === "paymentMethod") {
            setIsPaymentMethod(true)
            IsPaymentMethod = true
          }
          setIsModalReady(true)
          IsModalReady = true

          const obj = { Pol, Zip, Env, IsModalReady, IsQuote, IsPolicyPayment, IsDownPayment, SessionID, IsAutopay, IsTextToPay, IsPaymentMethod, fromToken };
          setContinueObj(obj)
          if (Type === "payment" || Type === "quote") {
            setIsLoading(false)
            setShowHomeMenu(true)
            if (window?.ReactNativeWebView) { // If mobile app react native webview
              setShowPaymentDisclaimer(false);
              if (obj.fromToken.current === true) {
                continueLoadToken(obj);
              }
            } else {
              setShowPaymentDisclaimer(true);
            }
          }
          else {
            continueLoadToken(obj)
          }
          // const payment = await GetPaymentData(Pol, Zip, Env)
          // if (IsModalReady && !!payment) {
          //   state.current = payment.State
          //   if (IsPolicyPayment || IsDownPayment) {
          //     if (payment.isMaintenance === 1) {
          //       ShowErrorMessage(payment.Message);
          //     } else if ((!IsQuote && (payment.Bln === '0' || payment.Bln === '0.00' || payment.Bln === '')) || (IsQuote && (payment.Amt === '0' || payment.Amt === '0.00' || payment.Amt === ''))) {
          //       LoadNoPaymentDueModal();
          //     } else {
          //       LoadPaymentModal(payment, SessionID, Pol);
          //     }
          //   } else if (IsAutopay) {
          //     LoadAutoPayModal()
          //   } else if (IsTextToPay) {
          //     isNotifications.current = true
          //     LoadNotificationsModal(payment, SessionID)
          //   }
          // }
          // else {
          //   //payment failed to load
          //   setIsLoading(false)
          //   setShowHomeMenu(true)
          // }
        } else {
          setIsLoading(false)
          setShowHomeMenu(true)
        }
      } else {
        //token failed to load
        setIsLoading(false)
        setShowHomeMenu(true)
        setIsModalReady(true)
        IsModalReady = true
        if (searchParams.get("OtherOptions") !== null && searchParams.get("OtherOptions") == 1) {
          setShowOtherOptions(true)
        }
      }

      //Show Other Options modal
      //?ShowOptions=1
      if (searchParams.get("ShowOptions") === "1") {
        setShowOtherOptions(true)
      }
    })()
  }, [])

  const handleShowModal = event => {
    if (!hasLoadedModal) {
      setHasLoadedModal(true);
    }
    setShowOtherOptions(true);
  };

  const continueLoadToken = async ({ Pol, Zip, Env, IsModalReady, IsQuote, IsPolicyPayment, IsDownPayment, SessionID, IsAutopay, IsTextToPay, IsPaymentMethod }) => {
    const payment = await GetPaymentData(Pol, Zip, Env)
    if (IsModalReady && !!payment) {
      state.current = payment.State
      if (IsPolicyPayment || IsDownPayment) {
        if (payment.isMaintenance === 1) {
          ShowErrorMessage(payment.Message);
        } else if ((!IsQuote && (payment.Bln === '0' || payment.Bln === '0.00' || payment.Bln === '')) || (IsQuote && (payment.Amt === '0' || payment.Amt === '0.00' || payment.Amt === ''))) {
          LoadNoPaymentDueModal();
        } else {
          LoadPaymentModal(payment, SessionID, Pol);
        }
      } else if (IsAutopay) {
        const today = new Date();
        const duedt = new Date(payment.DueDate);

        const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        const dayAfterTomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2);
        const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
        const dayBeforeYesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 2);
        if ( // show error if payment is due between 48 hours ago and 48 hours from now
          (duedt.getFullYear() === today.getFullYear() && duedt.getMonth() === today.getMonth() && duedt.getDate() === today.getDate()) ||
          (duedt.getFullYear() === tomorrow.getFullYear() && duedt.getMonth() === tomorrow.getMonth() && duedt.getDate() === tomorrow.getDate()) ||
          (duedt.getFullYear() === dayAfterTomorrow.getFullYear() && duedt.getMonth() === dayAfterTomorrow.getMonth() && duedt.getDate() === dayAfterTomorrow.getDate()) ||
          (duedt.getFullYear() === yesterday.getFullYear() && duedt.getMonth() === yesterday.getMonth() && duedt.getDate() === yesterday.getDate()) ||
          (duedt.getFullYear() === dayBeforeYesterday.getFullYear() && duedt.getMonth() === dayBeforeYesterday.getMonth() && duedt.getDate() === dayBeforeYesterday.getDate())
        ) {
          setIsLoading(false)
          setShowHomeMenu(true)
          setShowAutopayBlocked(true)
          window.sessionStorage.setItem('autopayBlocked', true);
        }
        else {
          LoadAutoPayModal()
        }
      } else if (IsTextToPay) {
        isNotifications.current = true
        LoadNotificationsModal(payment, SessionID)
      } else if (IsPaymentMethod) {
        isDefaultPayment.current = true
        LoadManagePaymentMethodsModal(payment, SessionID)
      }
    }
    else {
      //payment failed to load
      setIsLoading(false)
      setShowHomeMenu(true)
    }
  }

  useDidMountEffect(() => { //listener for closing no payment due modal
    if (showNoPaymentDue === false) {
      GoBack();
    }
  }, [showNoPaymentDue])

  useDidMountEffect(() => { //listener for closing autopay modal
    if (showAutopay === false) {
      if (autopayManagePayMethods.current === true) {
        //  nothing :(
      }
      else {
        if (isModalReady) {
          setShowLoadingText(false)
          setIsLoading(true)
        }
        GoBack();
      }
    }
  }, [showAutopay])

  async function timeout(delay) {
    return new Promise(res => setTimeout(res, delay));
  }

  function ShowErrorMessage(message) {
    setIsLoading(false)
    setErrorMessage(message)
  }

  // async function GoBack(override = false) {
  async function GoBack({ override, payment } = { override: false, payment: false }) {

    console.log("Going back...")
    if (isDownPayment.current === true) {
      if (paymentComplete.current === true) {
        setShowLoadingText(false)
        setIsLoading(true)
        const bindTokenResp = await createBindToken(amountPaid.current, paymentDate.current, confirmationNumber.current, quoteID.current, state.current, env)
        const bindToken = bindTokenResp.Token
        await timeout(6000);
        window.location.href = source.current === 'GetQuote_Next' ?
          `https://${getDomainQuoteRedesign()}/app/welcome?Token=${bindToken}` :
          `https://${getDomainQuote()}/get-a-quote/Binding.aspx?Token=${bindToken}`;
      } else {
        window.close()
      }
    }
    else if ((type.current === "payment") || (type.current === "autopay") || isAutopay || (type.current === "notifications") || isTextToPay || (type.current === "paymentMethod") || isPaymentMethod) {
      if (autopayManagePayMethods.current) {
        autopayManagePayMethods.current = false
        LoadAutoPayModal();
      }
      else {
        if (source.current.includes("TwilioSVCPortal") || source.current.includes("EmailSVCHub")) {
          window.close()
          window.location.href = "cure.com"
        }
        else if (source.current.includes("ODS")) {
          //from ODS autopay enrollment tool
          window.location.href = `https://${getRedirectEnv() === "staging" ? "odsstg" : getRedirectEnv() === "prepublish" ? "odsprep" : "callcenter"}.cure.com/Reports/AutoPayEnroll`
          setIsLoading(false)
          setShowHomeMenu(false)
        }
        else if (source.current.includes("Mobile")) {
          window.location.href = `${getMobileScheme()}${(payment)?"PaymentCenter/true":""}`
          setIsLoading(false)
          setShowHomeMenu(false)
        }
        else {
          window.location.href = `https://${getRedirectEnv()}/${(source.current == "QuickSVC") ? "quick-service" : "home"}`
          setIsLoading(false)
          setShowHomeMenu(false)
        }
      }
    } else if (override === true) {
      window.location.href = `https://myaccount${getRedirectEnv() === "staging" ? "stg" : getRedirectEnv() === "prepublish" ? "prep" : ""}.cure.com/home`
      setIsLoading(false)
      setShowHomeMenu(false)
    } else {
      //user entered policy and zip manually
      setIsLoading(false)
      setShowHomeMenu(true)
    }
  }

  const RetrieveOneIncSessionID = async (Env) => {
    const retrieveOneIncSessionID_resp = await retrieveOneIncSessionID(Env)
    sessionID.current = retrieveOneIncSessionID_resp?.data.PortalOneSessionKey
    return retrieveOneIncSessionID_resp?.data.PortalOneSessionKey
  }

  const GetPaymentData = async (pol, zip, env) => {
    let IsQuote = /^(AP|\d+)/.test(pol)
    setIsQuote(IsQuote)
    if (IsQuote && userEnteredPolicy) {
      pol = !!(parseInt(pol.replace("-", "")) - 1000000) ? (parseInt(pol.replace("-", "")) - 1000000) : pol
      console.log(pol)
    }

    let getPaymentInfoOneInc_resp;
    if (IsQuote) {
      getPaymentInfoOneInc_resp = await getQuotePaymentInfo(pol, zip, env)
    } else {
      getPaymentInfoOneInc_resp = await getPaymentInfoOneinc(pol, zip, env)
    }
    if (!!getPaymentInfoOneInc_resp && !!getPaymentInfoOneInc_resp.data) {
      email.current = getPaymentInfoOneInc_resp.data.Email
      state.current = getPaymentInfoOneInc_resp.data.State
      return getPaymentInfoOneInc_resp.data
    }
    else {
      ShowErrorMessage("There was a problem getting your information. Please try again later.")
    }
  }

  function LoadNoPaymentDueModal() {
    console.log("Loading no payment due modal...")
    setShowNoPaymentDue(true)
    setIsLoading(false)
    setShowHomeMenu(false)
  }
  function LoadPaymentModal(d, SessionID, Pol = "") {
    if (portalOneRef.current) {
      portalOneRef.current.env = env;
      portalOneRef.current.LoadPaymentModal(d, SessionID, Pol = "")
    }
  }
  function LoadNotificationsModal(d, SessionID) {
    if (portalOneRef.current) {
      portalOneRef.current.LoadNotificationsModal(d, SessionID)
    }
  }
  function LoadManagePaymentMethodsModal(d, SessionID) {
    if (portalOneRef.current) {
      portalOneRef.current.LoadManagePaymentMethodsModal(d, SessionID)
    }
  }
  function LoadInactivePaymentModal(d, SessionID) {
    if (portalOneRef.current) {
      portalOneRef.current.LoadInactivePaymentModal(d, SessionID)
    }
  }
  function LoadAutoPayModal() {
    console.log("Loading autopay modal...")
    setShowAutopay(true)
    setIsLoading(false)
    setShowHomeMenu(false)
  }
  async function submitPayment() {
    let IsQuote = /^(AP|\d+)/.test(pol)
    if ((IsQuote && !fromToken.current) || /^(QT)/.test(pol)) {
      ShowErrorMessage("Please enter a valid policy number.")
      return
    }
    ShowErrorMessage("")
    if (pol === "" || zip === "") {
      ShowErrorMessage("Please enter your Policy Number and Zipcode.")
      return
    }
    console.log("Submitting payment...")
    setIsLoading(true)
    setUserEnteredPolicy(true)
    const Payment = await GetPaymentData(pol, zip, env);
    if (!!Payment && Payment.hasOwnProperty("Message") && Payment.Message === "Policy Not Found") {
      ShowErrorMessage("Please enter a valid policy number.")
      return
    }
    if (Payment === undefined) {
      ShowErrorMessage("There was a problem getting your information. Please try again later.")
      return
    }
    state.current = Payment.State
    if (IsQuote) { // Quote or Application
      if (Payment.Amt == null) {
        ShowErrorMessage("Please enter a valid policy number.");
      } else if (Payment.Zip == '-1') {
        ShowErrorMessage("Invalid zip code.");
      } else if (Payment.Amt == '0' || Payment.Amt == '0.00' || Payment.Amt == '') {
        LoadNoPaymentDueModal();
      } else {
        LoadPaymentModal(Payment, sessionID.current);
        isDownPayment.current = true
      }
    } else { // Policy
      if (!!Payment && Payment.hasOwnProperty("isActive") && Payment.isActive === 0) {
        ShowErrorMessage("This policy is inactive. Please call 800-535-2873 to speak with a representative.")
        return
      }
      if (Payment.isMaintenance == 1) {
        ShowErrorMessage(Payment.Message);
      } else if (Payment.isActive == 1) {
        let BlnStr = Payment.Bln
        let Bln = parseFloat(BlnStr);
        if (Payment.Zip == '-1') {
          ShowErrorMessage("Invalid zip code.");
        } else if (Bln == 0 || isNaN(Bln)) {
          LoadNoPaymentDueModal();
        } else {
          setTypeD("payment");
          LoadPaymentModal(Payment, sessionID.current, pol);
        }
      } else {
        if (Payment.Amt == null || Payment.Amt === '0' || Payment.Amt === '0.0' || Payment.Amt === '0.00') {
          ShowErrorMessage("Your policy is paid in full. No payment required.");
        } else if (Payment.Zip == '-1') {
          ShowErrorMessage("Invalid zip code.");
        } else {
          LoadInactivePaymentModal(Payment, sessionID.current);
        }
      }
    }
  }
  return (
    <>
      {isLoading
        ? <Loading showText={showLoadingText} />
        : <ClientInfo show={showHomeMenu} pol={pol} setPol={setPol} zip={zip} setZip={setZip} handleShowModal={handleShowModal} errorMessage={errorMessage} setShowPaymentDisclaimer={setShowPaymentDisclaimer} showLoadingText={showLoadingText}></ClientInfo>
      }

      {/* Autopay Modal */}
      {<AutoPayModal autopayManagePayMethods={autopayManagePayMethods} show={showAutopay} setShow={setShowAutopay} isAutopay={isAutopay} pol={pol} zip={zip} env={env} GetPaymentData={GetPaymentData} managePaymentMethods={LoadManagePaymentMethodsModal} sessionID={sessionID.current} source={source.current} setIsLoading={setIsLoading} updateAutopayCompleted={() => { autopayIsComplete.current = true }}></AutoPayModal>}

      {/* Container for PortalOne interactions */}
      {isModalReady && <PortalOne ref={portalOneRef} setIsLoading={setIsLoading} setShowHomeMenu={setShowHomeMenu} setShowLoadingText={setShowLoadingText} GoBack={GoBack} pol={pol} zip={zip} env={env} email={email} GetPaymentData={GetPaymentData} paymentComplete={paymentComplete} isDownPayment={isDownPayment} amountPaid={amountPaid} paymentDate={paymentDate} confirmationNumber={confirmationNumber} quoteID={quoteID} isModalReady={isModalReady} isTextToPay={isTextToPay} isNotifications={isNotifications} sessionID={sessionID} state={state} type={typeD} source={sourceD}></PortalOne>}

      {/* CURE Modal (No payment due) */}
      <NoPaymentDue show={showNoPaymentDue} setShow={setShowNoPaymentDue}></NoPaymentDue>

      {/* Other options modal */}
      <Suspense fallback={<></>}>
        <OtherOptions
          show={showOtherOptions}
          setShow={setShowOtherOptions}
        />
      </Suspense>
      {/* Payment disclaimer modal */}
      <PaymentDisclaimer show={showPaymentDisclaimer} setShow={setShowPaymentDisclaimer} submitPayment={submitPayment} GoBack={GoBack} continueLoadToken={continueLoadToken} continueObj={continueObj} pol={pol}></PaymentDisclaimer>

      {/* Autopay blocked modal */}
      <AutopayBlocked show={showAutopayBlocked} setShow={setShowAutopayBlocked} submitPayment={submitPayment} GoBack={GoBack}></AutopayBlocked>


    </>
  )
}

export default Home